export const tableHeader = (theme) => {
    return {
        head: {
            zIndex: '290',
            position: "sticky",
            top: 0,
            backgroundColor: "#ffffff",
            height: '43px',
            whiteSpace: 'nowrap',
            minWidth: '41px'
        },
        headError: {
            zIndex: '290',
            position: "sticky",
            top: 0,
            backgroundColor: "#ffffff",
            height: '43px',
            whiteSpace: 'nowrap'
        },
        cell: {
            textAlign: 'center',
            padding: '0 15px!important'
        },
        weekend: {
            backgroundColor: '#ffe4c4'
        },
        name: {
            padding: '0 75px',
            textAlign: 'center'
        },
        pattern: {
            padding: '0 25px',
            textAlign: 'center'
        },
        errorStatus: {
            padding: '0px'
        },
        transparent: {
            color: 'transparent',
            backgroundColor: 'transparent'
        },
        workplanName: {
            fontWeight: 'bold'
        },
        calendarHeader: {
            paddingTop: 10,
            display: 'flex'
        },
        calendarHeaderStatus: {
            paddingLeft: 10
        }
    }
}

export const calendar = (theme) => {
    return {
        root: {
            width: '100%',
            marginTop: theme.spacing(3),
            marginBottom: '-13px'
        },
        tableWrapper: {
            overflow: 'scroll',
            position: 'fixed',
            bottom: 0,
            zIndex: '1',
        },
        tableFixed: {
            width: '100%',
            margin: 'auto',
            borderCollapse: 'separate',
            borderSpacing: '0'
        },
        gotSkills: {
            color: 'orange'
        },
        isOT: {
            color: 'red'
        },
        isNotOT: {
            color: 'black'
        },
        input: {
            height: '36px',
            textAlign: 'right'
        },
        noMaxWidth: {
            maxWidth: 'none',
        },

        buttonStatus: {
            borderRadius: '20px',
            margin: theme.spacing(),
            minWidth: '120px'
        },
        rollout: {
            justifyContent: 'flex-end'
        },
        header: {
            display: 'inline-flex',
            marginTop: '20px',
            marginBottom: '10px',
            padding: '0 0 5px 0px',
            width: '100%',
        },
        flexButtonStatus: {
            flex: 1,
            marginLeft: '20px',
            marginTop: '20px',
            maxWidth: '120px'
        },
        flexWrapper: {
            flex: 1
        },
        headerTwo: {
            display: 'inline-flex',
            marginTop: '15px',
            marginBottom: '15px',
            padding: '0 0 5px 0px',
            width: '100%',
        },
        headerItem: {
            minWidth: '120px',
            margin: '0 5px'
        },
        alignFont: {
            display: 'flex'
        },
        effectiveDate: {
            marginRight: '8%',
            padding: '5px 0px 5px 0px',
        },
        Typo: {
            padding: '5px 0px 5px 0px',
        },
        pausedStatus: {
            borderColor: 'darkorange',
            color: 'darkorange'
        },
        stopStatus: {
            borderColor: 'red',
            color: 'red'
        },
        activeStatus: {
            borderColor: 'green',
            color: 'green'
        },
        regularStatus: {
            borderColor: 'rgba(0, 0, 0, 0.26)',
            color: 'black'
        },
        textField: {
            marginLeft: theme.spacing(),
            marginRight: theme.spacing(),
            padding: '0px 110px 5px 0px'
        },
        dense: {
            marginTop: 16,
        },
        groupTextField: {
            border: '1px solid #a5a5a5',
            borderRadius: '4px',
            padding: '0px 5px 10px 5px',
            display: 'grid'
        },
        notes: {
            minHeight: '100px',
            width: "100%",
            marginLeft: theme.spacing(),
            marginRight: theme.spacing(),
        },
        ButtonAction: {
            margin: '5px',
            borderColor: '#E6EDF5',
            '&:disabled': {
                border: 0
            }
        },
        labelButton: {
            textTransform: 'capitalize'
        },
        disabledIcon: {
            color: '#b9b9b9'
        },
        labelHeader: {
            color: '#A9A9A9',
            fontWeight: 100,
            fontSize: '12px',
            display: 'block'
        },
        infoHeader: {
            fontWeight: 500,
            color: '#545454',
            fontSize: '13px'
        },
        CloseOpen: {
            marginTop: 65
        },
        OpenClose: {
            marginTop: -65
        },
        verticalAlign: {
            verticalAlign: 'middle'
        },
        greenStatus: {
            border: '1px solid #58cc5b',
            backgroundColor: 'rgba(88,204,91,0.71)',
            fontWeight: 700
        },
        redStatus: {
            border: '1px solid #dc4747',
            backgroundColor: 'rgba(220, 71, 71, 0.83)',
            fontWeight: 700
        },
        yellowStatus: {
            border: '1px solid #deb71d',
            backgroundColor: 'rgba(222, 183, 29, 0.77)',
            fontWeight: 700
        },
        whiteStatus: {
            backgroundColor: 'white',
            border: '1px solid #B5CBE3',
            fontWeight: 700,
            color: '#666666'
        },
        SideBar: {
            minWidth: '420px'
        },
        selectWidth: {
            width: '135px'
        },
        superSelect: {
            width: '155PX',
            '& .reactSelect__indicators': {
                position: 'absolute',
                height: '30px',
                right: '0px !important'
            }
        },
        toolTipContainer: {
            width: 'inherit'
        }
    }
}

export const workplanTableIndex = (theme) => {
    return {
        createButton: {
            zIndex: 288,
            marginRight: 5,
            color: '#bfbfbf',
            borderColor: '#bfbfbf',
            marginTop: '15px'
        },
        label: {
            color: '#bfbfbf',
            fontSize: 12,
            paddingLeft: '5px',
        },
        icon: {
            fontSize: 12
        },
        workplanName: {
            fontWeight: 'bold',
            marginTop: 11
        },
        calendarHeader: {
            paddingTop: 10,
            paddingBottom: 10,
            display: 'flex',
            height: '64px'
        },
        editHeader: {
            backgroundColor: '#0A54A2',
            color: 'white',
            width: '100%',
            height: '64px',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 20
        },
        calendarHeaderStatus: {
            paddingTop: 10,
            paddingLeft: 10
        },
        calendarHeaderStatusInfo: {
            paddingTop: 10,
            paddingLeft: 8
        },
        tagContainer: {
            backgroundColor: 'white',
            padding: '8px 12px',
            boxShadow: '0px 3px 6px #F7F9FC',
            border: '1px solid #E6EDF5',
            borderRadius: 2,
            // height: 48
        },
        divUnassigned: {
            color: '#0A54A2',
            height: '100%',
            paddingTop: 6
        },
        employeeNameSpan: {
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        },
        employeeNameCell: {
            display: "flex",
            alignItems: 'center',
            width: '100%'
        },

        tagContainerShift: {
            borderLeft: '4px solid #0A54A2'
        },
        tagContainerPaycode: {
            borderLeft: '4px solid #58cc5b'
        },
        buttonLineActions: {
            float: 'right',
            display: 'none',
            width: 0,
            height: 0,
            marginRight: 25
        },
        actionCellEE: {
            width: 190
        },
        divRelief: {
            paddingLeft: 16
        },
        divQuota: {
            textAlign: 'left'
        },
        divQuotaJob: {
            textAlign: 'center'
        },
        actionCellRelief: {
            height: 14
        },
        actionCell: {
            height: 32,
            '&:hover': {
                '& .buttonLineActions': {
                    display: 'inherit'
                }
            }
        },
        divActionCellLabel: {
            height: 32,
            minWidth: 200
            // paddingTop: 4
        },
        divEmployeeCellLabel: {
            height: 32,
            paddingTop: 6,
            overflow: 'hidden'
        },
        iconArrowPeriod: {
            marginRight: 4,
            marginLeft: 4,
            height: 12,
            paddingTop: 1
        },
        iconArrowPeriodTooltip: {
            marginRight: 4,
            marginLeft: 4,
            height: 12,
            marginTop: 4
        },
        rowPadding: {
            padding: 4
        },
        schedulePatternNameInputRoot: {
            fontSize: 13,
            height: 28,
            width: 200,
            backgroundColor: 'white'
        },
        schedulePatternNameInput: {
            padding: '0px 0px 0px 10px'
        },
        labelRoot: {
            fontSize: 12
        },
        iconCustomSingleValue: {
            marginRight: 10,
            marginTop: 2
        },
        selectShiftLineEdit: {
            width: 200,
            marginLeft: 5
        },
        ButtonChip: {
            border: '1px solid #D7D7D7', // + theme.colors.primary, 
            borderRadius: 4,
            display: 'inline-block',
            width: 36,
            height: 36,
            textAlign: 'center',
            marginLeft: 5,
            // marginTop: 2,
            paddingTop: 7,
            cursor: 'pointer',
            '&.active': {
                opacity: 0.25
            },
            backgroundColor: 'white',
        },
        iconButton: {
            color: '#0A54A2'
        },
        buttonSave: {
            width: 50
        },
        buttonSubmit: {
            minWidth: "100px",
            color: '#FFFFFF',
            backgroundColor: '#1a518a',
            boxShadow: '0px 0px 12px #0A54A229',
            borderRadius: '5px',
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            padding: '6px 16px',
            opacity: '1',
            fontWeight: "bold",
            '&:hover': {
                backgroundColor: 'rgb(18,56,96)',
                opacity: '70%'
            }
        },
        workplanButtonAction: {
            margin: '5px',
            borderColor: '#E6EDF5',
            '&:disabled': {
                border: 0
            }
        },
        workplanSplitButton: {
            position: 'absolute',
            right: '30px'
        },
        select: {
            width: 175,
            height: 28,
            marginBottom: 0,
            marginTop: 0,
            color: '#333333'
        },
        td: {
            width: 'auto'
        },
        'thead tr th:first-child': {
            minWidth: 48
        },
        buttonEditShiftLineToolBar: {
            height: 34,
            marginLeft: 5
        },
        buttonEditShiftLineToolBarDisabled: {
            height: 34,
            marginLeft: 5,
            backgroundColor: theme.colors.secondary[100],
            pointerEvents: 'none',
            '&:hover': {
                backgroundColor: `${theme.colors.secondary[100]} !important`
            }
        },
        buttonSaveChanges: {
            backgroundColor: '#1a518a',
            color: 'white',
            textTransform: 'inherit',
            '&:hover': {
                backgroundColor: theme.colors.primary[400]
            }
        },
        buttonSaveChangesDisabled: {
            border: '1px solid #bdbdbd',
            color: '#bdbdbd',
            backgroundColor: 'white',
            textTransform: 'inherit'
        },
        buttonCancelEdit: {
            backgroundColor: 'white',
            border: '1px solid #1a518a',
            textTransform: 'inherit',
            color: '#1a518a'
        },
        buttonAssign: {
            height: '28px !important',
            fontSize: '12px !important',
            lineHeight: '28px !important'
        },
        borderRed: {
            borderColor: 'red'
        },
        tableToolbar: {
            height: 56,
            display: 'flex',
            paddingTop: 10,
            paddingLeft: 10,
            position: 'relative'
        },
        tableToolbarRight: {
            right: 16,
            position: 'absolute',
            display: 'flex'
        },
        quotaNegative: {
            fontWeight: 'bold',
            color: 'red'
        },
        divDataviewData: {
            width: 100,
            overflow: 'hidden',
            textAlign: 'center',
            paddingLeft: 4,
            paddingRight: 4
        },
        iconInfoWorkplan: {
            fontSize: 18,
            marginTop: 3,
            color: "#bfbebe"
        },
        dateTypo: {
            flex: '1',
            color: '#878787',
            fontSize: '12px'
        },
        divValueWorkplanDetails: {
            paddingLeft: 10,
            paddingBottom: 10,
            maxWidth: 450
        },
        chipStatusMargin: {
            marginRight: 10,
            // paddingTop: 5
        },
        divChipStatusLabel: {
            paddingLeft: 4,
            width: 80
        },
        divStatus: {
            display: 'flex'
        },
        small: {
            borderRadius: 30,
            lineHeight: '22px',
            display: 'inherit'
        },
        chipTagStatus: {
            width: 102
        },
        tableColumnButton: {
            width: 34,
            border: '1px solid #0A54A2',
            cursor: 'pointer',
            height: 34,
            display: 'inline-block',
            marginTop: 1,
            marginLeft: 6,
            paddingLeft: 9,
            paddingTop: 5,
            borderRadius: 4,
            backgroundColor: 'transparent',
            color: '#0A54A2'
        },
        disabledButton: {
            cursor: 'default',
            border: '1px solid #bdbdbd',
            color: '#bdbdbd'
        },
        buttonSelected: {
            backgroundColor: '#0A54A2',
            color: 'white',
            '&:hover': {
                backgroundColor: theme.colors.primary[400]
            }
        },
        buttonDisabled: {
            borderColor: '#bdbdbd'
        },
        iconOwner: {
            marginLeft: 5
        },
        iconLongArrowRight: {
            marginRight: 5,
            marginLeft: 5,
            marginTop: 1
        },
        iconExchange: {
            marginRight: 5,
            marginTop: 1
        },
        location: {
            maxWidth: 145,
            paddingLeft: 5,
            overflow: 'hidden',
            direction: 'rtl',
            textOverflow: 'ellipsis',
            textAlign: 'left',
            whiteSpace: 'nowrap'
        },
        locationJob: {
            maxWidth: 145,
            paddingLeft: 20
        },
        totalsColumn: {
            paddingLeft: 20,
            paddingRight: 20
        },
    }
}

export const app = (theme) => {
    return {
        manageWorkplanContainer: {
            marginTop: '-24px',
            paddingBottom: '0px'
        },
        titleWrapper: {
            display: 'flex',
            paddingTop: 10,
        },
        titleApp: {
            fontFamily: 'Montserrat',
            marginBottom: '0px',
            paddingBottom: '0px',
        },
        workPlanList: {
            position: "absolute",
            top: "198px",
            left: "0",
            width: "100%"
        },
        headerFixed: {
            backgroundColor: 'white',
            zIndex: '289',
            position: 'fixed',
            width: '100%',
            transition: 'margin 225ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
            left: '0',
            padding: '0 22px',
            paddingTop: '70px'
        },
        iconButton: {
            paddingRight: '5px'
        },
        topButtonsContainer: {
            display: 'flex',
            height: '40px',
            marginTop: '12px',
        },
        addNew: {
            minWidth: '185px',
            marginTop: '12px'
        },
        searchContainer: {
            display: 'flex',
            marginTop: '12px',
            position: 'relative',
            borderRadius: theme.shape.borderRadius,
            backgroundColor: '#FFFFFF',
            border: '1px solid #B5CBE3',
            marginLeft: 0,
            marginRight: '15px',
            height: '40px',
            [theme.breakpoints.up('sm')]: {
                marginLeft: 'auto',
                width: 'auto',
            },
        },
        searchIcon: {
            width: theme.spacing() * 5,
            height: '100%',
            color: '#6EA0D7',
            position: 'absolute',
            pointerEvents: 'dense',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        inputRoot: {
            color: 'inherit',
            width: '100%',
        },
        inputInput: {
            paddingTop: theme.spacing(),
            paddingRight: theme.spacing(),
            paddingBottom: theme.spacing(),
            paddingLeft: theme.spacing() * 5,
            transition: theme.transitions.create('width'),
            width: '100%',
            [theme.breakpoints.up('md')]: {
                width: 200,
            },
        },
        SideBar: {
            minWidth: '420px'
        },

        root: {
            // width: '100%',
            display: 'flex',
            height: '100vh',
            // position: 'relative',
        },
        fullHeight: {
            height: '100%'
        },
        textAlignCentered: {
            textAlign: 'center'
        },
        settingContainer: {
            width: '99%',
            paddingLeft: 20
        },
        drawerPaper: {
            width: '16%',
            backgroundColor: '#0a54a2',
            minWidth: 240
        },
        drawer: {
            flexShrink: 0,
            width: '16%',
            minWidth: 240
        },
        drawerPaperV2: {
            width: 280,
            backgroundColor: '#FFFFFF',
            minWidth: '170px'
        },
        drawerV2: {
            flexShrink: 0,
            zIndex: 2,
        },
        drawerWrapperV2: {
            height: '100%',
        },
        navElement: {
            fontWeight: 700,
        },
        listItem: {
            padding: '16px'
        },
        listItemNoHover: {
            color: '#3A3A3A',
            fontWeight: 700,
            '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0)',
            }
        },
        selected: {
            color: '#0A54A2 !important',
            backgroundColor: 'rgba(0, 0, 0, 0) !important'
        },
        icon: {
            color: '#0a54a2',
            fontSize: '20px',
            minWidth: 32,
        },
        content: {
            flex: 1,
        },
        logoDrawer: {
            backgroundColor: '#6EA0D7',
            textAlign: 'center',
            padding: '20px',
            margin: '20px',
            border: '1px solid #6ea0d7',
            borderRadius: '3px',
            minHeight: '1px'
        },
        logoImg: {
            width: '80%'
        },
        backdrop: {
            width: '100%',
            height: '100%',
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: 1
        },
        contentWrapper: {
            zIndex: 0,
            position: 'relative'
        }
    }
}

export const filtersContainer = (theme) => {
    return {
        filter: {
            marginLeft: 4,
            // marginTop: '-8px',
            // marginBottom: '4px',
            cursor: "pointer",
            fontSize: '16px',
            marginRight: '0px',
            '& span': {
                color: '#545454',
                marginRight: '0px',
            },
            '& span .number': {
                marginRight: '0px',
                color: '#989898',
                fontSize: '10px',
                display: 'flex'
            },
            '& span:hover': {
                borderBottom: '2px solid #0A54A2',
                color: '#0A54A2',
            },
            '& span:hover .number': {
                border: '0',
                color: '#0A54A2',
            },
            '& span.active': {
                borderBottom: '2px solid #0A54A2',
                color: '#0A54A2',
            },
            '& span.active .number': {
                color: '#0A54A2',
                border: '0'
            }
        },
        chipTagStatus: {
            marginLeft: 5
        }
    }
}

export const workPlan = (theme) => {
    return {
        green: {
            color: 'green',
        },
        red: {
            color: 'red',
        },
        darkorange: {
            color: 'darkorange',
        },
        blue: {
            color: 'blue',
        },
        name: {
            width: '20%',
            fontSize: "0.875em",
            // paddingLeft: "24px",
            whiteSpace: 'nowrap',
            fontWeight: "700",
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        },
        description: {
            width: '20%'
        },
        descriptionTolltip: {
            width: '100%',
            height: 52,
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap'
        },
        status: {
            width: '10%',
            minWidth: '115px',
            textAlign: 'center'
        },
        job: {
            width: '20%',
            fontSize: "0.875em"
        },
        duration: {
            width: '10%',
            fontSize: "0.875em",
            textAlign: 'center'
        },
        dates: {
            fontSize: "0.875em",
            textAlign: 'center',
            width: '10%',
        },
        noMaxWidth: {
            maxWidth: 'none',
        },
        buttonStatus: {
            borderRadius: '20px',
            margin: theme.spacing(),
            minWidth: '120px'
        },
        infoContainer: {
            display: 'flex',
            width: '100%',
            height: '100%',
            lineHeight: "53px"
        },
        chipStatusMargin: {
            marginRight: 10,
            paddingBottom: 6
        },
        divStatus: {
            display: 'flex'
        },
        greenStatus: {
            border: '1px solid #58cc5b',
            backgroundColor: 'rgba(88,204,91,0.71)',
            fontWeight: 700
        },
        redStatus: {
            border: '1px solid #dc4747',
            backgroundColor: 'rgba(220, 71, 71, 0.83)',
            fontWeight: 700
        },
        yellowStatus: {
            border: '1px solid #deb71d',
            backgroundColor: 'rgba(222, 183, 29, 0.77)',
            fontWeight: 700
        },
        whiteStatus: {
            backgroundColor: 'white',
            border: '1px solid #B5CBE3',
            fontWeight: 700,
            color: '#666666'
        },
        divChipStatusLabel: {
            paddingLeft: 4,
            width: 70
        },
        small: {
            borderRadius: 30,
            lineHeight: '22px',
            display: 'inherit'
        },
        iconArrowPeriod: {
            marginRight: 4,
            marginLeft: 4,
            height: 12,
            marginTop: 4
        }
    }
}

export const workPlanForm = (theme) => {
    return {
        title: {
            border: "1px solid #E6EDF5",
            display: "inline-block",
            borderRadius: "30px",
            padding: "0 20px",
            color: "#767676",
            fontSize: "1em",
            lineHeight: "33px",
            marginBottom: "0px"
        },
        icon: {
            paddingRight: "10px"
        },
        numberContainer: {
            alignItems: 'left',
            padding: '15px 0px',
            marginTop: '10px'
        },
        radioContainer: {
            display: 'grid',
            marginRight: '30px',
            '& .MuiFormGroup-root': {
                display: 'block'
            },
            '& .MuiFormControlLabel-labelPlacementStart': {
                flexDirection: 'row',
                marginLeft: '0px',
                marginRight: '10px',
                '& span': {
                    fontSize: '14px',
                    color: '#767676',
                    '& .MuiSvgIcon-root': {
                        color: '#0A54A2',
                        stroke: '#0A54A2',
                        strokeWidth: '0px',
                        transform: 'scale(0.85)'
                    },
                    '& .MuiSvgIcon-root:last-child': {
                        display: 'none'
                    }
                },
                '& span.Mui-checked': {
                    '& .MuiSvgIcon-root': {
                        color: '#0A54A2',
                        stroke: '#0A54A2',
                        strokeWidth: '4px',
                        transform: 'scale(0.85)'
                    },
                    '& .MuiSvgIcon-root:last-child': {
                        display: 'none'
                    }
                }
            }

        },
        formContainer: {
            padding: '0 24px',
            backgroundColor: '#F8FAFC',
            position: 'absolute',
            width: '100%'
        },
        label: {
            width: '100%',
            color: '#878787',
            fontSize: '12px'
        },
        closeIcon: {
            transform: "scale(0.68)",
            float: "right",
            cursor: "pointer"
        },
        numberInput: {
            marginTop: '10px',
            marginBottom: '10px',
            width: '100px'
        },
        HeaderForm: {
            margin: '0px -24px',
            padding: '15px 24px 15px 24px',
            borderBottom: '1px solid #E6EDF5',
            backgroundColor: 'white'
        },
        textfield: {
            border: '1px solid #E6EDF5',
            backgroundColor: 'white',
            borderRadius: '4px',
            width: '100%',
            padding: '0px',
            margin: '5px 5px 5px 0px',
            display: 'block',
            paddingLeft: '10px',
            paddingRight: '10px',
            height: '42px',
            color: '#545454',
            textTransform: 'Capitalize',
            fontSize: '0.75em',
        },
        input: {
            color: '#545454',
            textTransform: 'Capitalize',
            fontSize: '0.75em',
            height: '25px'
        },
        InputLabel: {
            fontSize: '0.875em',
            marginBottom: '0',
            color: '#878787',
            marginTop: '30px'

        },
        SelectTag: {
            backgroundColor: 'white',
            border: '1px solid #E6EDF5',
            height: '40px',
            marginTop: '4px',
            padding: '0 10px',
            borderRadius: '4px',
            lineHeight: '40px',
            overflow: 'hidden',
            position: 'relative'
        },
        chip: {
            backgroundColor: 'white',
            border: '1px solid #E6EDF5',
            borderRadius: '4px',
            fontSize: '10px',
            color: '#545454',
            height: '30px',
            marginTop: '-4px',
            marginRight: '4px'
        },
        chips: {
            marginLeft: '26px',
            marginRight: '26px',
            display: 'inlineBlock',
            fontSize: '0.75em'
        },
        iconRight: {
            position: 'absolute',
            right: '16px',
            top: '0'
        },
        iconLeft: {
            display: 'inlineBlock',
            position: 'absolute'
        },
        ActionButtons: {
            padding: 0
        },
        inputNumber: {
            width: '96px',
        },
        dateTypo: {
            flex: '1',
            color: '#878787',
            fontSize: '12px'
        }
    }
}

export const calendarActionForm = (theme) => {
    return {
        formFields: {
            padding: '15px 0px',
            display: 'block'
        },
        formContainer: {
            padding: '0 24px',
            backgroundColor: '#F8FAFC',
            position: 'absolute',
            width: '100%',
        },
        HeaderForm: {
            margin: '0px -24px',
            padding: '15px 24px 15px 24px',
            borderBottom: '1px solid #E6EDF5',
            backgroundColor: 'white'
        },
        groupTextField: {
            marginTop: '15px',
            backgroundColor: 'white',
            border: '1px solid #E6EDF5',
            borderRadius: '5px',
            padding: '0 10px'
        },
        numberInput: {
            marginBottom: '10px'
        },
        stepNumber: {
            position: 'absolute',
            paddingTop: '3px',
            color: 'white',
            fontSize: '0.75rem',
            width: '24px',
            height: '24px',
            textAlign: 'center',
        },
        stepCircle: {
            color: '#1a518a',
            fontSize: '24px'
        },
        stepIconContainer: {
            display: 'inline'
        },
        title: {
            border: "1px solid #E6EDF5",
            display: "inline-block",
            borderRadius: "30px",
            padding: "0 20px",
            color: "#767676",
            fontSize: "1em",
            lineHeight: "33px",
            marginBottom: "0px"
        },
        closeIcon: {
            transform: "scale(0.68)",
            float: "right",
            cursor: "pointer"
        },
        headerSectionLabel: {
            color: '#6b6b6b',
            padding: '10px 15px',
            borderBottom: '1px solid #E6EDF5',
            margin: '0 -10px'
        },
        datesCollapse: {
            height: 29,
            opacity: '0',
            transition: 'height 0.2s ease-out, opacity 0s ease 0s'
        },
        collapseIcon: {
            color: '#6ea0d7',
            float: 'right',
            marginTop: '4px',
            transition: 'all 0.2s ease',
        },
        dateClass: {
            height: 110,
            opacity: '1',
            overflow: 'hidden',
            transitionDuration: '0.2s, 300ms',
            transitionDelay: '0ms, 150ms',
        },
        hideDateClassIcon: {
            transform: 'rotate(-180deg)'
        },
        dateHeaderContainer: {
            marginLeft: '50px',
            color: '#c3c3c3',
            display: 'inline'
        },
        label: {
            color: '#878787',
            marginTop: '10px'
        },
        location: {
            paddingLeft: 10,
        },
        dateOffset: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
        }
    }
}

export const contentSidebar = (theme) => {
    return {
        dense: {
            marginTop: 16,
        },
        modalContainer: {
            padding: '10px 14px',
        },
        spanLine: {
            display: 'block',
        },
        nameSpan: {
            fontWeight: 'bold',
        },
        modalContainerDelete: {
            padding: '10px 14px',
            textAlign: 'center',
            marginTop: '20px',
            marginBottom: '10px',
        },
        inputSelect: {
            boxSizing: 'content-box !important'
        },
        inputNumber: {
            width: '96px',
        },
        superSelect: {
            width: '100%',
            margin: '5px 5px 5px 0px',
            '& .openShift__multi-value': {
                backgroundColor: '#F7F9FC',
                border: '1px solid #E6EDF5',
                margin: '4px'
            },
            '& .openShift__multi-value__label': {
                padding: 0,
                height: '27px',
                lineHeight: '27px',
                color: theme.colors.secondary[400],
                fontSize: '10px',
                paddingLeft: '20px'
            },
            '& .openShift__dropdown-indicator': {
                '& path': {
                    color: theme.colors.primary[400],

                }
            },
            '& .openShift__control': {
                border: '1px solid #E6EDF5',
                borderRadius: '4px',
                width: '100%',
                padding: '0px',
                margin: '5px 5px 5px 0px',
                display: 'block',
                height: '42px',
                color: theme.colors.secondary[400],
                textTransform: 'Capitalize',
                fontSize: '0.75em',
                overflow: 'hidden'
            },
            '& .openShift__indicators': {
                position: 'relative',
                height: '40px',
            },
            '& .openShift__indicator-separator': {
                display: 'none'
            },
            '& .openShift__value-container': {
                lineHeight: '27px',
                paddingLeft: '16px',
                width: 'calc(100% - 40px)',
                float: 'left'
            },
            '& .openShift__multi-value__remove': {
                display: 'block',
                marginLeft: '4px',
                width: '20px',
                height: '20px',
                marginTop: '4px',
                marginRight: '4px',
                textAlign: 'center',
                position: 'relative',
                '&:hover': {
                    backgroundColor: '#357ebd',
                    '& svg': {
                        color: '#FFFFFF'
                    }
                },
                '& svg': {
                    marginTop: '5px',
                    position: 'absolute',
                    display: 'inlineBlock',
                    left: 0,
                    width: '100%'
                }
            }
        },
        SelectCSS: {
            '&:hover': {
                backgroundColor: '#F7F9FC'
            }
        },

    }
}

export const tableBody = (theme) => {
    return {
        NOOVERFLOW: {
            overflowY: 'hidden !important'
        },
        green: {
            color: 'green',
        },
        red: {
            color: 'red',
        },
        darkorange: {
            color: 'darkorange',
        },
        day: {
            backgroundColor: "#f5f5f5"
        },
        cell: {
            padding: '0 6px',
            textAlign: 'center',
            height: '49px',
            whiteSpace: 'nowrap'
        },
        cellSelect: {
            padding: '0 15px',
            textAlign: 'center',
            minWidth: '220px !important',
            height: '49px',
            display: 'flex',
            alignItems: 'center',
        },
        cellError: {
            padding: '0px !important',
            textAlign: 'center',
            backgroundColor: 'white',
            margin: '0px !important',
            width: '20px'
        },
        divCellError: {
            display: 'flex'
        },
        noPadding: {
            padding: '0 !important',
            textAlign: 'center'
        },
        cellWithBackground: {
            backgroundColor: 'white',
            padding: '0 20px',
            textAlign: 'center',
            height: '49px'
        },
        rowActionsButtons: {
            display: 'inherit',
            borderLeft: '1px solid rgba(224, 224, 224, 1)',
            borderRight: '1px solid rgba(224, 224, 224, 1)',
            position: 'sticky',
            left: '90.25%',
            background: 'white',
            borderTop: '1px solid rgba(224, 224, 224, 1)',
        },
        textField: {
            marginLeft: theme.spacing(),
            marginRight: theme.spacing(),
        },
        dense: {
            marginTop: 16,
        },
        groupTextField: {
            border: '1px solid #a5a5a5',
            borderRadius: '4px',
            padding: '0px 5px 10px 5px'
        },
        notes: {
            minHeight: '100px',
            width: "100%",
            marginLeft: theme.spacing(),
            marginRight: theme.spacing(),
        },
        noMaxWidth: {
            maxWidth: 'none',
        },
        noBorderBottom: {
            borderBottom: 0,
        },
        sideBorders: {
            padding: '0 10px !important',
            textAlign: 'left !important',
            borderRight: '1px solid rgba(224, 224, 224, 1)',
            minWidth: '150px',
            backgroundColor: 'white'
        },
        childrenIcon: {
            paddingRight: '5px',
            paddingTop: '5px',
            fontSize: '20px',
            float: 'left',
        },
        radioShift: {
            backgroundColor: 'white',
            borderRight: '1px solid rgba(224, 224, 224, 1)',
        },
        warningColor: {
            color: '#f46f6f',
            minWidth: '25px'
        },
        statusCell: {
            padding: '0px',
            minWidth: '25px',
        },
        selectContainer: {
            minWidth: '200px',
            width: '100%'
        },
        selectContainerChildren: {
            width: '90%'
        },
        hideText: {
            display: 'none',
            position: 'absolute',
            width: '0',
            height: '0',
            color: 'transparent',
        },
        inputSelect: {
            boxSizing: 'content-box !important'
        },
        greenStatus: {
            border: '1px solid #58cc5b',
            backgroundColor: 'rgba(88,204,91,0.71)',
            fontWeight: 700
        },
        redStatus: {
            border: '1px solid #dc4747',
            backgroundColor: 'rgba(220, 71, 71, 0.83)',
            fontWeight: 700
        },
        yellowStatus: {
            border: '1px solid #deb71d',
            backgroundColor: 'rgba(222, 183, 29, 0.77)',
            fontWeight: 700
        },
        whiteStatus: {
            backgroundColor: 'white',
            border: '1px solid #B5CBE3',
            fontWeight: 700,
            color: '#666666'
        },
        superSelect: {
            width: '100%',
            margin: '0',
            height: 'auto',
            '& .openShift__multi-value': {
                backgroundColor: '#F7F9FC',
                border: '1px solid #E6EDF5',
                margin: '4px'
            },
            '& .openShift__multi-value__label': {
                padding: 0,
                height: '27px',
                lineHeight: '27px',
                color: theme.colors.secondary[400],
                fontSize: '10px',
                paddingLeft: '20px'
            },
            '& .openShift__dropdown-indicator': {
                '& path': {
                    color: theme.colors.primary[400],

                }
            },
            '& .openShift__menu': {
                maxHeight: '150px'
            },
            '& .openShift__menu-list': {
                maxHeight: '150px'
            },
            '& .openShift__control': {
                border: '1px solid #E6EDF5',
                borderRadius: '4px',
                width: '100%',
                padding: '0px',
                margin: '5px 5px 5px 0px',
                display: 'block',
                height: '38px',
                color: theme.colors.secondary[400],
                textTransform: 'Capitalize',
                fontSize: '0.75em',
                overflow: 'hidden'
            },
            '& .openShift__indicators': {
                position: 'relative',
                height: '40px',
            },
            '& .openShift__indicator-separator': {
                display: 'none'
            },
            '& .openShift__value-container': {
                lineHeight: '27px',
                paddingLeft: '10px',
                width: 'calc(100% - 40px)',
                float: 'left'
            },
            '& .openShift__multi-value__remove': {
                display: 'block',
                marginLeft: '4px',
                width: '20px',
                height: '20px',
                marginTop: '4px',
                marginRight: '4px',
                textAlign: 'center',
                position: 'relative',
                '&:hover': {
                    backgroundColor: '#357ebd',
                    '& svg': {
                        color: '#FFFFFF'
                    }
                },
                '& svg': {
                    marginTop: '5px',
                    position: 'absolute',
                    display: 'inlineBlock',
                    left: 0,
                    width: '100%'
                }
            }
        },
        superSelectChild: {
            float: 'right',
            width: 'calc(100% - 18px)',
            marginTop: '-4px',
            marginRight: 0
        },
        tagContainer: {
            backgroundColor: 'white',
            padding: '8px 12px',
            boxShadow: '0px 3px 6px #F7F9FC',
            border: '1px solid #E6EDF5',
            borderRadius: 2,
            // height: 48
        },
        tagContainerShift: {
            borderLeft: '4px solid #0A54A2'
        },
        tagContainerPaycode: {
            borderLeft: '4px solid #58cc5b'
        },
        shiftCell: {
            display: 'inline-flex'
        }
    }
}

export const workplanTableBody = (theme) => ({
    NOOVERFLOW: {
        overflowY: 'hidden !important'
    },
    green: {
        color: 'green',
    },
    red: {
        color: 'red',
    },
    darkorange: {
        color: 'darkorange',
    },
    day: {
        backgroundColor: "#f5f5f5"
    },
    cell: {
        padding: '0 6px',
        textAlign: 'center',
        height: '49px',
        whiteSpace: 'nowrap'
    },
    cellSelect: {
        padding: '0 15px',
        textAlign: 'center',
        minWidth: '220px !important',
        height: '49px',
        display: 'flex',
        alignItems: 'center',
    },
    cellError: {
        padding: '0px !important',
        textAlign: 'center',
        backgroundColor: 'white',
        margin: '0px !important',
        width: '20px'
    },
    divCellError: {
        display: 'flex'
    },
    noPadding: {
        padding: '0 !important',
        textAlign: 'center'
    },
    cellWithBackground: {
        backgroundColor: 'white',
        padding: '0 20px',
        textAlign: 'center',
        height: '49px'
    },
    rowActionsButtons: {
        display: 'inherit',
        borderLeft: '1px solid rgba(224, 224, 224, 1)',
        borderRight: '1px solid rgba(224, 224, 224, 1)',
        position: 'sticky',
        left: '90.25%',
        background: 'white',
        borderTop: '1px solid rgba(224, 224, 224, 1)',
    },
    textField: {
        marginLeft: theme.spacing(),
        marginRight: theme.spacing(),
    },
    dense: {
        marginTop: 16,
    },
    groupTextField: {
        border: '1px solid #a5a5a5',
        borderRadius: '4px',
        padding: '0px 5px 10px 5px'
    },
    notes: {
        minHeight: '100px',
        width: "100%",
        marginLeft: theme.spacing(),
        marginRight: theme.spacing(),
    },
    noMaxWidth: {
        maxWidth: 'none',
    },
    noBorderBottom: {
        borderBottom: 0,
    },
    sideBorders: {
        padding: '0 10px !important',
        textAlign: 'left !important',
        borderRight: '1px solid rgba(224, 224, 224, 1)',
        minWidth: '150px',
        backgroundColor: 'white'
    },
    childrenIcon: {
        paddingRight: '5px',
        paddingTop: '5px',
        fontSize: '20px',
        float: 'left',
    },
    radioShift: {
        backgroundColor: 'white',
        borderRight: '1px solid rgba(224, 224, 224, 1)',
    },
    warningColor: {
        color: '#f46f6f',
        minWidth: '25px'
    },
    statusCell: {
        padding: '0px',
        minWidth: '25px',
    },
    selectContainer: {
        minWidth: '200px',
        width: '100%'
    },
    selectContainerChildren: {
        width: '90%'
    },
    hideText: {
        display: 'none',
        position: 'absolute',
        width: '0',
        height: '0',
        color: 'transparent',
    },
    inputSelect: {
        boxSizing: 'content-box !important'
    },
    greenStatus: {
        border: '1px solid #58cc5b',
        backgroundColor: 'rgba(88,204,91,0.71)',
        fontWeight: 700
    },
    redStatus: {
        border: '1px solid #dc4747',
        backgroundColor: 'rgba(220, 71, 71, 0.83)',
        fontWeight: 700
    },
    yellowStatus: {
        border: '1px solid #deb71d',
        backgroundColor: 'rgba(222, 183, 29, 0.77)',
        fontWeight: 700
    },
    whiteStatus: {
        backgroundColor: 'white',
        border: '1px solid #B5CBE3',
        fontWeight: 700,
        color: '#666666'
    },
    superSelect: {
        width: '100%',
        margin: '0',
        height: 'auto',
        '& .openShift__multi-value': {
            backgroundColor: '#F7F9FC',
            border: '1px solid #E6EDF5',
            margin: '4px'
        },
        '& .openShift__multi-value__label': {
            padding: 0,
            height: '27px',
            lineHeight: '27px',
            color: theme.colors.secondary[400],
            fontSize: '10px',
            paddingLeft: '20px'
        },
        '& .openShift__dropdown-indicator': {
            '& path': {
                color: theme.colors.primary[400],

            }
        },
        '& .openShift__menu': {
            maxHeight: '150px'
        },
        '& .openShift__menu-list': {
            maxHeight: '150px'
        },
        '& .openShift__control': {
            border: '1px solid #E6EDF5',
            borderRadius: '4px',
            width: '100%',
            padding: '0px',
            margin: '5px 5px 5px 0px',
            display: 'block',
            height: '38px',
            color: theme.colors.secondary[400],
            textTransform: 'Capitalize',
            fontSize: '0.75em',
            overflow: 'hidden'
        },
        '& .openShift__indicators': {
            position: 'relative',
            height: '40px',
        },
        '& .openShift__indicator-separator': {
            display: 'none'
        },
        '& .openShift__value-container': {
            lineHeight: '27px',
            paddingLeft: '10px',
            width: 'calc(100% - 40px)',
            float: 'left'
        },
        '& .openShift__multi-value__remove': {
            display: 'block',
            marginLeft: '4px',
            width: '20px',
            height: '20px',
            marginTop: '4px',
            marginRight: '4px',
            textAlign: 'center',
            position: 'relative',
            '&:hover': {
                backgroundColor: '#357ebd',
                '& svg': {
                    color: '#FFFFFF'
                }
            },
            '& svg': {
                marginTop: '5px',
                position: 'absolute',
                display: 'inlineBlock',
                left: 0,
                width: '100%'
            }
        }
    },
    superSelectChild: {
        float: 'right',
        width: 'calc(100% - 18px)',
        marginTop: '-4px',
        marginRight: 0
    },
    tagContainer: {
        backgroundColor: 'white',
        padding: '8px 12px',
        boxShadow: '0px 3px 6px #F7F9FC',
        border: '1px solid #E6EDF5',
        borderRadius: 2,
        // height: 48
    },
    tagContainerShift: {
        borderLeft: '4px solid #0A54A2'
    },
    tagContainerPaycode: {
        borderLeft: '4px solid #58cc5b'
    },
    shiftCell: {
        display: 'inline-flex'
    },
    buttonLineActions: {
        // padding: '0px 0px 0px 5px',
        // width: 20,
        float: 'right',
        display: 'none'
    },
    menuActions: {
        border: '1px solid #E6EDF5',
        borderRadius: 4
    },
    divButtonAction: {
        paddingLeft: 5,
        width: 41,
        textAlign: "center"
    },
    divEmployeeName: {
        paddingTop: 14
        // height: 49,
        // display: 'table-cell',
        // verticalAlign: 'middle'
    },
    menuHeaderActions: {
        minWidth: 180,
        textAlign: 'center',
        margin: '4px 0px',
        paddingBottom: 4
    },
    menuOtherActions: {
        border: '1px solid #E6EDF5'
    },
    buttonHeaderAction: {
        height: 32,
        fontSize: 12,
        lineHeight: 32,
        margin: '0px 2px'
    },
    employeeCell: {
        display: "flex",
        '&:hover': {
            '& div': {
                '& div': {
                    display: 'inline-block'
                }
            }
        }
    },
    patternCell: {
        '&:hover': {
            '& div': {
                display: 'inline-block'
            }
        }
    },
    ButtonChip: {
        border: '1px solid #D7D7D7', // + theme.colors.primary, 
        borderRadius: 4,
        display: 'inline-block',
        width: 28,
        height: 28,
        textAlign: 'center',
        marginTop: 2,
        paddingTop: 3,
        cursor: 'pointer',
        '&.active': {
            opacity: 0.25
        },
        backgroundColor: 'white',
    },
    buttonAddShiftLine: {
        border: '1px solid #D7D7D7',
        borderRadius: 4,
        height: 36
    },
    popoverSlOptions: {
        zIndex: 100,
        marginLeft: 194
    },
    popoverEeOptions: {
        zIndex: 100,
        marginLeft: 185
    }
});

export const tableToolbar = (theme) => {
    return {
        rootToolbar: {
            display: 'flex',
            width: '100%',
            position: 'absolute',
            left: 0,
            border: '1px solid #e8eff5',
            backgroundColor: 'white',
        },
        actionButtons: {
            float: 'left',
            lineHeight: '58px'
        },
        addShift: {
            float: 'left',
            marginLeft: '20px',
            marginTop: '5px'
        },
        button: {
            margin: theme.spacing(),
        },
        iconButton: {
            paddingRight: 5,
            fontSize: 22
        },
        spacer: {
            flex: '1 1 100%',
        },
        title: {
            flex: '0 0 auto',
        },
        superSelect: {
            width: '100%',
            maxWidth: '400px',
            height: '32px',
            lineHeight: '32px',
            margin: '5px 5px 5px 0px',
            '& .openShift__multi-value': {
                backgroundColor: '#F7F9FC',
                border: '1px solid ' + theme.colors.primary[200],
                margin: '4px'
            },
            '& .openShift__multi-value__label': {
                padding: 0,
                height: '27px',
                lineHeight: '27px',
                color: theme.colors.secondary[400],
                fontSize: '10px',
                paddingLeft: '20px'
            },
            '& .openShift__menu': {
                zIndex: 999,
                position: 'absolute'
            },
            '& .openShift__control': {
                border: '1px solid ' + theme.colors.primary[200],
                borderRadius: '4px',
                width: '100%',
                padding: '0px',
                margin: '5px 5px 5px 0px',
                display: 'block',
                height: '42px',
                color: theme.colors.secondary[400],
                textTransform: 'Capitalize',
                fontSize: '0.75em',
                overflow: 'hidden'
            },
            '& .openShift__indicators': {
                position: 'relative',
                height: '32px',
            },
            '& .openShift__dropdown-indicator': {
                '& path': {
                    color: theme.colors.primary[500]
                }
            },
            '& .openShift__indicator-separator': {
                display: 'none'
            },
            '& .openShift__value-container': {
                lineHeight: '27px',
                paddingLeft: '10px',
                width: 'calc(100% - 40px)',
                float: 'left'
            },
            "& .openShift__control, .openShift__value-container": {
                minHeight: 'inherit',
                height: '32px',
                lineHeight: '22px',
            },
            '& .openShift__single-value': {
                height: '32px',
                lineHeight: '32px'
            },
            '& .openShift__placeholder': {
                textAlign: 'left',
                position: 'relative',
                height: '32px',
                lineHeight: '32px',
            }
        },
        selectColumns: {
            marginTop: '12px',
            '& .openShift__control': {
                backgroundColor: 'transparent'
            }
        },
        buttonExcel: {
            margin: theme.spacing(),
            padding: 0,
            marginTop: '14px',
            '& svg': {
                margin: 0,
                padding: 0
            },
            '& button': {
                padding: 0
            }
        },
        Options: {
            '&:hover': {
                backgroundColor: "#F7F9FC",
            }
        },
        OptionDisabled: {
            opacity: 0.5
        },
        menuOtherActions: {
            height: 300,
            overflow: 'auto'
        },
        popoverEeOptions: {
            zIndex: 100
        },
        tableColumnButton: {
            width: 34,
            minWidth: 34,
            border: '1px solid #0A54A2',
            cursor: 'pointer',
            height: 34,
            display: 'inline-block',
            marginTop: 1,
            marginLeft: 6,
            paddingLeft: 9,
            paddingTop: 5,
            borderRadius: 4,
            backgroundColor: 'transparent',
            color: '#0A54A2',
            verticalAlign: 'middle !important'
        },
        buttonSelected: {
            // borderColor: '#0A54A2',
            // backgroundColor: '#0A54A214',
            backgroundColor: '#0A54A2',
            color: 'white',
            '&:hover': {
                backgroundColor: theme.colors.primary[400]
            }
        },
        buttonDisabled: {
            borderColor: '#bdbdbd'
        },
        menuCustomSelect: {
            width: 250
        },
        disabledButton: {
            cursor: 'default',
            border: '1px solid #bdbdbd',
            color: '#bdbdbd'
        },
        disabledOption: {
            cursor: 'default',
            color: '#bdbdbd'
        }
    }
}